import React from 'react';
import { CheckIcon, DownloadIcon, GiftIcon } from 'lucide-react';
import { CheckoutButton } from '../CheckoutButton';
import { CollectionMockup } from '../CollectionMockup';
import { OFFER_FEATURES } from '../../data/collection';
import { LAUNCH_LABEL, OFFER_BUY_LABEL, PRICE } from '../../data/checkout';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-title" className="w-full bg-ivory-deep" data-id="element-262" data-mp="aijtybs9g671">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:px-8 lg:py-24" data-id="element-263" data-mp="6irinrbhflxz">
        <div className="grid min-w-0 grid-cols-1 items-center gap-8 rounded-[24px] bg-paper p-5 ring-1 ring-ivory-line sm:gap-10 sm:rounded-[28px] sm:p-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-14 lg:p-12" data-id="element-264" data-mp="1pgi27x9k1ei">
          <div className="order-2 min-w-0 lg:order-1" data-id="element-265" data-mp="3nz10b8z33sgq">
            <CollectionMockup className="max-w-[min(320px,100%)] lg:max-w-[600px]" data-id="element-266" data-mp="3iyd7qiv7j3ke" />
          </div>

          <div className="order-1 min-w-0 lg:order-2" data-id="element-267" data-mp="3ex9pxqtlmxgj">
            <p className="inline-flex items-center rounded-full bg-coral-deep px-4 py-2 text-[0.85rem] font-extrabold uppercase tracking-[0.08em] text-white" data-id="element-268" data-mp="3exta7e6q1xxq">
              {LAUNCH_LABEL}
            </p>

            <div id="offer-price" className="mt-5" data-id="element-269" data-mp="1fktrcpk76pbi">
              <p className="text-[1rem] text-graphite-soft" data-id="element-270" data-mp="10um7q6igf098">
                Precio de referencia <span className="font-semibold line-through" data-id="element-271" data-mp="15snyldm4g3v9">{PRICE.compareAtLabel}</span>
              </p>
              <p className="mt-1 flex flex-wrap items-baseline gap-x-3 gap-y-1" data-id="element-272" data-mp="1ti0ail8u2q19">
                <span className="font-serif text-[3.3rem] font-semibold leading-none text-graphite sm:text-[3.8rem]" data-id="element-273" data-mp="1yhctguwl3cyk">
                  {PRICE.label}
                </span>
                <span className="text-[1.1rem] font-bold text-graphite" data-id="element-274" data-mp="1kjwkbbmwl534">ARS</span>
              </p>
              <p className="mt-2 text-[1.1rem] font-bold text-graphite" data-id="element-275" data-mp="1oli4zj5oinnv">{PRICE.note}</p>
            </div>

            <h2 id="oferta-title" className="mt-6 flex items-start gap-2.5 font-serif text-[1.55rem] font-semibold leading-tight text-coral-ink text-balance sm:text-[1.85rem]" data-id="element-276" data-mp="9518ryjjzjqs">
              <GiftIcon className="mt-1 h-6 w-6 shrink-0" aria-hidden data-id="element-277" data-mp="2as447db0ze94" />
              La colección completa + 5 bonos de regalo
            </h2>

            <ul className="mt-5 grid grid-cols-1 gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-278" data-mp="25zt3474jtmez">
              {OFFER_FEATURES.map(feature => <li key={feature} className="flex items-start gap-2.5 text-[1.02rem] font-semibold text-graphite" data-id="element-279" data-mp="2106q9ysmu86p">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage-tint" data-id="element-280" data-mp="1s1me7ghkuwrg">
                    <CheckIcon className="h-3.5 w-3.5 text-sage-ink" strokeWidth={3} aria-hidden data-id="element-281" data-mp="1n1gjfrg0gu55" />
                  </span>
                  {feature}
                </li>)}
            </ul>

            <div className="relative mt-6 rounded-[16px] bg-blush px-5 py-5 sm:px-6" data-id="element-282" data-mp="3hgj152ytj7xi">
              <span aria-hidden className="pointer-events-none absolute inset-[6px] rounded-[11px] border border-dashed border-coral/50" data-id="element-283" data-mp="3cgofpextbaju" />
              <p className="relative font-serif text-[1.2rem] font-semibold text-graphite" data-id="element-284" data-mp="3kxoya5ctzy08">{PRICE.perModelLead}</p>
              <p className="relative mt-1 font-serif text-[1.65rem] font-semibold leading-tight text-coral-ink sm:text-[1.85rem]" data-id="element-285" data-mp="3oxpenvjhqj9x">
                {PRICE.perModelHighlight}
              </p>
              <p className="relative mt-1.5 text-[0.9rem] font-semibold text-graphite-soft" data-id="element-286" data-mp="2jfpvlbnf98m">{PRICE.perModelNote}</p>
            </div>

            <div className="mt-7" data-id="element-287" data-mp="360xuzl01e25c">
              <CheckoutButton id="offer-cta" label={OFFER_BUY_LABEL} size="lg" data-id="element-288" data-mp="361z9jzg9h6rt" />
            </div>
            <p className="mt-4 flex items-start gap-2 text-[0.95rem] leading-relaxed text-graphite-soft" data-id="element-289" data-mp="3ayzfmad429ix">
              <DownloadIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage-ink" aria-hidden data-id="element-290" data-mp="3fzwykp5y37lh" />
              Acceso al enlace de descarga después del pago · Archivos PDF · Sin envío físico
            </p>
          </div>
        </div>
      </div>
    </section>;
}